// Torneos globales: torneo activo visible para todos, unión con sesión
// verificada y ranking público ordenado por puntaje (desempate: precisión).
async function request(url, options = {}, authenticated = true) {
  const sessionToken = localStorage.getItem('nacanaca-session') || '';
  if (authenticated && !sessionToken) throw new Error('Inicia sesión para continuar.');
  const response = await fetch(url, {
    ...options,
    headers: {
      Accept: 'application/json',
      ...(authenticated ? { Authorization: `Bearer ${sessionToken}` } : {}),
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...options.headers,
    },
  });
  const payload = await response.json().catch(() => ({ error: 'El servidor devolvió una respuesta inválida.' }));
  if (!response.ok) {
    const error = new Error(payload.error || `El servidor respondió ${response.status}.`);
    error.status = response.status;
    error.code = payload.code;
    throw error;
  }
  return payload;
}

export const fetchActiveTournament = () => request('/api/tournaments/active', {}, false);

export const fetchTournamentInvite = (token) => (
  request(`/api/tournaments/invite?token=${encodeURIComponent(token)}`, {}, false)
);

export const joinTournament = ({ token, tournamentId }) => request('/api/tournaments/join', {
  method: 'POST',
  body: JSON.stringify({ token, tournamentId }),
});

export const fetchTournamentRanking = (tournamentId, limit = 100) => request(
  `/api/tournaments/ranking?tournamentId=${encodeURIComponent(tournamentId)}&limit=${encodeURIComponent(limit)}`,
  {},
  false,
);
